import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { BankAccountsService } from 'src/app/services/bank-accounts/bank-accounts.service';
import { ConsigneeService } from 'src/app/services/consignees/consignee.service';
import { ApiResponse } from 'src/app/models/IApiResponse';

@Component({
  selector: 'app-add-bank-account',
  templateUrl: './add-bank-account.component.html',
  styleUrls: ['./add-bank-account.component.css']
})
export class AddBankAccountComponent implements OnInit{
  form!: FormGroup;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;
  consignees: any[] = [];

  constructor(
    private bankAccountsService:BankAccountsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private consigneeService: ConsigneeService,
  ){
    this.form = this.formBuilder.group({
      bank_name: ['', Validators.required],
      account_no: ['', Validators.required],
      consignee_id: ['', Validators.required],
    });
  }
  
  ngOnInit(): void {
    this.getConsignees();
  }

  getConsignees(): void {
    this.consigneeService.getAllConsignees().subscribe((response: ApiResponse)=>this.consignees=response.data);
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.bankAccountsService.saveBankAccount(formData).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);
         
          // Redirect back to makes list
          this.router.navigate(['settings/bank-accounts-list']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
